import { Component, OnInit } from "@angular/core";
import jwt_decode from "jwt-decode";
import PerfectScrollbar from "perfect-scrollbar";
import { DataService } from "src/app/services/data.service";

declare const $: any;

//Metadata
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;

  children?: ChildrenItems[];
}

export interface ChildrenItems {
  path: string;
  title: string;
  ab: string;
  type?: string;
}
// dataservice

// //Menu Items
export const ROUTES: RouteInfo[] = [];
@Component({
  selector: "app-sidebar-cmp",
  templateUrl: "sidebar.component.html",
  styles: [
    `
      li.nav-item.active > a.single-link > i.material-icons {
        color: #3c4858;
      }
    `,
  ],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  ps: any;
  sidebar: any = [];
  userdetails: any;
  fleetLogo: any = 0;
  exponentIcon = "assets/img/exponent/exponent_logo_whilte.png";
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  constructor(private dataService: DataService) {
    // this.nativeElement = element.nativeElement;
    // this.sidebarVisible = false;
  }

  ngOnInit() {
    // to fect sidebar menu
    // this.getSideBar();

    // this.menuItems = ROUTES.filter(menuItem => menuItem);
    const sidebar = localStorage.getItem("ec_sidebar");
    // console.log(sidebar);
    this.genarateSidebar(JSON.parse(sidebar));
    // console.log(this.menuItems);
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>(
        document.querySelector(".sidebar .sidebar-wrapper")
      );
      this.ps = new PerfectScrollbar(elemSidebar);
    }
  }

  genarateSidebar(menus) {
    const tok = this.dataService.getToken();
    const decodedToken: any = jwt_decode(tok);
    this.userdetails = decodedToken;
    // console.log("userdetails ----------->",decodedToken,decodedToken.utype);
    if (
      decodedToken.utype.name == "Bosch LOS user" ||
      decodedToken.utype.name == "Bosch LOS Partner" ||
      decodedToken.uname == "Bosch LOS Admin"
    ) {
      this.fleetLogo = 1;
    }

    // this.dataService.getUserByType(decodedToken.utype).subscribe((res: any) => {
    //     console.log('User tupe details----->',res);
    //   }, error => {
    //     console.log('getDeviceIdsForpartner error: ', error);
    //   });
    // console.log('menus--->',menus);

    menus.forEach((element) => {
      // console.log('element',element)
      var menu: any = {};
      if (element.menu_id) {
        menu = {
          path: "/" + element?.menu_id?.url ? element.menu_id.url : "",
          title: element.menu_id.menu_label,
          // type: 'sub',
          icontype: element.menu_id.icon,
        };
      } else {
        // const menu:any=''
      }
      const submenus = element.submenus;
      const nestedmenu: any = [];
      if (submenus.length >= 1) {
        // console.log(submenus);
        submenus.forEach((submenu) => {
          const submenuDetail = element.menu_id?.submenus.find(
            (val) => val._id == submenu.submenu_id
          );
          const submenuobj = {
            path: submenuDetail?.url ? submenuDetail?.url : "",
            title: submenuDetail?.submenu_label,
            ab: submenuDetail?.shortname,
            sequence: submenuDetail?.sequence,
          };
          // console.log(submenuobj);

          if (submenuobj.path !== undefined && submenuobj.title !== undefined) {
            nestedmenu.push(submenuobj);
          }
        });

        if (element.menu_id) {
          nestedmenu.sort((a, b) => a.sequence - b.sequence);
          menu.children = nestedmenu;
          menu.type = "sub";
          menu.collapse = element.menu_id.url;
        }
      } else {
        if (element.menu_id) {
          menu.type = "link";
        }
      }
      this.sidebar.push(menu);
      // console.log(this.sidebar);
      this.menuItems = this.sidebar;
    });
  }

  getSideBar() {
    this.dataService.getSidebar().subscribe(
      (response: any) => {
        // this.sidebar = response

        response.result.forEach((element) => {
          const menu: any = {
            path: "/" + element.url,
            title: element.menu_label,
            // type: 'sub',
            icontype: element.icon,
            payload: element,
          };
          const submenus = element.submenus;
          const nestedmenu: any = [];
          if (submenus.length >= 1) {
            // console.log(submenus);
            submenus.forEach((submenu) => {
              const submenuobj = {
                path: submenu.url,
                title: submenu.submenu_label,
                ab: submenu.shortname,
              };
              nestedmenu.push(submenuobj);
            });
            menu.children = nestedmenu;
            menu.type = "sub";
            menu.collapse = element.url;
          } else {
            menu.type = "link";
          }
          this.sidebar.push(menu);
          this.menuItems = this.sidebar;
        });

        // console.log(this.sidebar);
      },
      (error) => {
        console.log("Sidebar: ", error);
      }
    );
  }
  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      this.ps.update();
    }
  }
  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }

  isAllowed(menu, submenu) {
    console.log("menu------------>", menu);
    console.log("submenu------------>", submenu);
    return true;
  }
}
